var _path, _rect, _path2, _rect2, _rect3, _rect4, _path3, _rect5, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrRoundedSquares(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 24.5C37.5 23.3954 36.6046 22.5 35.5 22.5H32C30.8954 22.5 30 23.3954 30 24.5V30V35.5C30 36.6046 30.8954 37.5 32 37.5H37.5H45H50.5C51.6046 37.5 52.5 36.6046 52.5 35.5V32C52.5 30.8954 51.6046 30 50.5 30H45H39.5C38.3954 30 37.5 29.1046 37.5 28V24.5Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 22.5,
    width: 7.5,
    height: 7.5,
    rx: 2,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 2C60 0.895431 59.1046 0 58 0H54.5C53.3954 0 52.5 0.89543 52.5 2V5.5C52.5 6.60457 51.6046 7.5 50.5 7.5H47C45.8954 7.5 45 8.39543 45 9.5V15V20.5C45 21.6046 45.8954 22.5 47 22.5H50.5C51.6046 22.5 52.5 21.6046 52.5 20.5V17C52.5 15.8954 53.3954 15 54.5 15H58C59.1046 15 60 14.1046 60 13V7.5V2Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 52.5,
    width: 7.5,
    height: 7.5,
    rx: 2,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 52.5,
    width: 7.5,
    height: 7.5,
    rx: 2,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 45,
    width: 7.5,
    height: 7.5,
    rx: 2,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45 47C45 45.8954 45.8954 45 47 45H52.5H58C59.1046 45 60 45.8954 60 47V52.5V58C60 59.1046 59.1046 60 58 60H54.5C53.3954 60 52.5 59.1046 52.5 58V54.5C52.5 53.3954 51.6046 52.5 50.5 52.5H47C45.8954 52.5 45 51.6046 45 50.5V47Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 45,
    width: 7.5,
    height: 7.5,
    rx: 2,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 24.5C22.5 23.3954 21.6046 22.5 20.5 22.5H17C15.8954 22.5 15 23.3954 15 24.5V28C15 29.1046 14.1046 30 13 30H7.5H2C0.895431 30 0 30.8954 0 32V35.5C0 36.6046 0.89543 37.5 2 37.5H7.5H13C14.1046 37.5 15 38.3954 15 39.5V45V50.5C15 51.6046 15.8954 52.5 17 52.5H20.5C21.6046 52.5 22.5 51.6046 22.5 50.5V45V37.5V30V24.5Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2C0 0.895431 0.89543 0 2 0H5.5C6.60457 0 7.5 0.89543 7.5 2V5.5C7.5 6.60457 8.39543 7.5 9.5 7.5H13C14.1046 7.5 15 6.60457 15 5.5V2C15 0.895431 15.8954 0 17 0H20.5C21.6046 0 22.5 0.89543 22.5 2V5.5C22.5 6.60457 23.3954 7.5 24.5 7.5H30H35.5C36.6046 7.5 37.5 8.39543 37.5 9.5V13C37.5 14.1046 36.6046 15 35.5 15H32C30.8954 15 30 15.8954 30 17V20.5C30 21.6046 29.1046 22.5 28 22.5H24.5C23.3954 22.5 22.5 21.6046 22.5 20.5V17C22.5 15.8954 21.6046 15 20.5 15H15H9.5C8.39543 15 7.5 15.8954 7.5 17V20.5C7.5 21.6046 6.60457 22.5 5.5 22.5H2C0.89543 22.5 0 21.6046 0 20.5V15V7.5V2Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrRoundedSquares);
export default __webpack_public_path__ + "static/media/qr-rounded-squares.ea23e0d613c313fb4e8ef5944caab3a8.svg";
export { ForwardRef as ReactComponent };